import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header', {
    attrs: {
      "isClassifyBtn": true
    }
  }), _c('div', {
    staticClass: "flash-sale"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head-title"
  }, [_c('span', [_vm._v("您当前的位置：")]), _c('span', {
    staticClass: "back-home",
    on: {
      "click": function click($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("首页")]), _c('span', {
    staticClass: "slash"
  }, [_vm._v("/")]), _c('span', {
    staticClass: "low-title"
  }, [_vm._v("限时抢购")])]), _vm._m(0), _vm._l(_vm.flashIngList, function (item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "flash-nav"
    }, [_c('div', {
      staticClass: "nav-left"
    }, [_c('span', {
      staticClass: "nav-tit"
    }, [_vm._v("抢购中")]), _c('div', {
      staticClass: "end-sale"
    }, [_vm._v(" 距结束还剩： "), _c('CountDown', {
      attrs: {
        "time": item.surplus
      }
    })], 1)])]), _c('div', {
      staticClass: "flash-list"
    }, _vm._l(item.detailList, function (list, num) {
      return _c('div', {
        key: num,
        staticClass: "flash-item",
        on: {
          "click": function click($event) {
            return _vm.goOrder(list, item.status, item.id, list.button_status);
          }
        }
      }, [_c('img', {
        attrs: {
          "src": list.source_url
        }
      }), _c('div', {
        staticClass: "flash-cont"
      }, [_c('h3', {
        staticClass: "text-line"
      }, [_vm._v(_vm._s(list.product_name))]), _c('p', [_vm._v(_vm._s(list.nature_value))]), _c('div', {
        staticClass: "flash-price"
      }, [_c('Price', {
        attrs: {
          "price": String(list.discount_price)
        }
      }), _c('div', {
        staticClass: "delprice"
      }, [_c('Price', {
        attrs: {
          "price": String(list.original_price)
        }
      })], 1)], 1), item.status === 1 && list.button_status !== 0 ? _c('div', {
        staticClass: "sale-btn"
      }, [_vm._v("去抢购")]) : _vm._e(), list.button_status === 0 ? _c('div', {
        staticClass: "disabled-btn"
      }, [_vm._v("已抢购")]) : _vm._e()])]);
    }), 0)]);
  }), _vm._l(_vm.flashList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "nostarted"
    }, [_c('div', {
      staticClass: "flash-nav"
    }, [_c('div', {
      staticClass: "nav-left nostart"
    }, [_c('span', {
      staticClass: "nav-tit"
    }, [_vm._v("即将开始")]), _c('div', {
      staticClass: "end-sale"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.start_time)))])])]), _c('div', {
      staticClass: "flash-list"
    }, _vm._l(item.detailList, function (list, num) {
      return _c('div', {
        key: num,
        staticClass: "flash-item"
      }, [_c('img', {
        attrs: {
          "src": list.source_url
        }
      }), _c('div', {
        staticClass: "flash-cont"
      }, [_c('h3', [_vm._v(_vm._s(list.product_name))]), _c('p', [_vm._v(_vm._s(list.nature_value))]), _c('div', {
        staticClass: "flash-price"
      }, [_c('Price', {
        attrs: {
          "price": String(list.discount_price)
        }
      }), _c('div', {
        staticClass: "delprice"
      }, [_c('Price', {
        attrs: {
          "price": String(list.original_price)
        }
      })], 1)], 1), _c('div', {
        staticClass: "saleing-btn"
      }, [_vm._v(_vm._s(_vm._f("formatDate")(item.start_time)))])])]);
    }), 0)]);
  })], 2)]), _c('BackTop'), _c('Footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "img-title"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/flashsale-cont.png")
    }
  })]);
}];
export { render, staticRenderFns };